import axios from '../axiosConfig'; // Adjust the import path accordingly

//const express_server_url = process.env.REACT_APP_SERVER_URL;
const express_server_url = window.SERVER_CONFIG.REACT_APP_SERVER_URL;
const dotnet_server_url = window.SERVER_CONFIG.REACT_APP_DOTNETSERVER_URL;

var WebApiUrl = express_server_url;
WebApiUrl = express_server_url.replace("localhost", window.location.hostname);

const EyeCheckUpSync = {

  InsertEyeCheckUp: async (data) => {
    //
    try {
      
      //const apiUrl = `${express_server_url}/api/Agent/Agent`;
      const apiUrl = `${WebApiUrl}/api/EyeCheckUp/CreateEyeCheckUp`;
      console.log(apiUrl);
      console.log(data);
      const response = await axios.post(apiUrl, {
        title: data.title,
        partyId: data.partyId,
        registrationDate: data.registrationDate,
        status: data.status,
        eyeCheckUpLens: { ...data.eyeCheckUpLens },
        eyeCheckUpCont: { ...data.eyeCheckUpCont },
        eyeCheckUpTrans: { ...data.eyeCheckUpTrans },
        eyeCheckUpAR: { ...data.eyeCheckUpAR },
        eyeCheckUpIm: { ...data.eyeCheckUpIm },
        pdr: data.pdr,
        pdl: data.pdl,
        pdrl: data.pdrl,
        nextVisitDate: data.nextVisitDate,
        lensExpRemDate: data.lensExpRemDate,
        prescribedBy: data.prescribedBy,
        lenseType: data.lenseType,
        deliveryInDays: data.deliveryInDays,
        deliveryTime: data.deliveryTime,
        remark: data.remark,
        printLenseStatus: data.printLenseStatus,
        printLensEye: data.printLensEye

      });

      console.log("Response:", response.data);
      return true;
    } catch (error) {
      console.error("Error:", error.message);

      if (error.response && error.response.status === 401) {
        alert("Failed");
      } else {
        alert("An error occurred. Please try again.");
      }
    }
  },


  // ************************* Get All ***************************
    getAllEyyCheckUp: async (filters) => {
        try {
            const apiUrl = `${WebApiUrl}/api/EyeCheckUp/GetAllEyeCheckUp`;
            const response = await axios.post(apiUrl, filters, {
                withCredentials: true,
            });
            console.log('Response:', response.data.result);
            return response.data.result;

        } catch (error) {
            console.error('Error:', error.message);
        }
    },

  // ************************* Get By Id ****************************
  getEyeCheckUpById: async (eyeCheckUpId) => {
    try {
      const apiUrl = `${WebApiUrl}/api/EyeCheckUp/GetEyeCheckUpById?id=${eyeCheckUpId}`;
      const response = await axios.get(apiUrl, {}, {
        withCredentials: true,
      });
      console.log('Response:', response.data.result);
      return response.data.result;
    } catch (error) {
      console.error('Error:', error.message);
    }
  },

  // ************************* Delete ****************************
  deleteEyeCheckUp: async (eyeId) => {
    try {

      const apiUrl = `${WebApiUrl}/api/EyeCheckUp/DeleteEyeCheckUp?id=${eyeId}`;
      const response = await axios.delete(apiUrl, {
        withCredentials: true,
      });
      console.log('Delete Response:', response.data);
      return true;
    } catch (error) {
      console.error('Error:', error.message);
    }
  },

  // *************************** Update ***************************

  updateEyeCheckUp: async (data) => {
    console.log(data.id)
    try {
      const apiUrl = `${WebApiUrl}/api/EyeCheckUp/UpdateEyeCheckUp?Id=${data.id}`;
      console.log(apiUrl);
      const response = await axios.put(apiUrl, {
        id: data.id,
        title: data.title,
        partyId: data.partyId,
        registrationDate: data.registrationDate,
        status: data.status,
        eyeCheckUpLens: { ...data.eyeCheckUpLens },
        eyeCheckUpCont: { ...data.eyeCheckUpCont },
        eyeCheckUpTrans: { ...data.eyeCheckUpTrans },
        eyeCheckUpAR: { ...data.eyeCheckUpAR },
        eyeCheckUpIm: { ...data.eyeCheckUpIm },
        pdr: data.pdr,
        pdl: data.pdl,
        pdrl: data.pdrl,
        nextVisitDate: data.nextVisitDate,
        lensExpRemDate: data.lensExpRemDate,
        prescribedBy: data.prescribedBy,
        lenseType: data.lenseType,
        deliveryInDays: data.deliveryInDays,
        deliveryTime: data.deliveryTime,
        remark: data.remark,
        printLenseStatus: data.printLenseStatus,
        printLensEye: data.printLensEye
      });

      console.log("Response:", response.data);
      return response.data.isSuccess;
    } catch (error) {
      console.error("Error:", error.message);

      if (error.response && error.response.status === 401) {
        alert("Failed");
      } else {
        alert("An error occurred. Please try again.");
      }
    }
  },



}
export default EyeCheckUpSync;